import { useSelector } from 'react-redux';
import SaveToListButton from '../../../../buttons/SaveToListButton';

const ProductSaveToListButton = () => {
  const current = useSelector(s => s.products?.current);
  const itemPartNumber = useSelector(
    s => s.products.byId?.[current]?.itemPartNumber
  );
  const partNumber = useSelector(s => s.products.byId?.[current]?.partNumber);
  const quantity = useSelector(
    s =>
      s.products.priceAndAvailability?.[current]?.quantity ??
      s.products.priceAndAvailability?.[partNumber]?.quantity
  );

  return (
    <SaveToListButton
      itemPartNumber={itemPartNumber || partNumber}
      quantity={quantity}
      fromPDPPage
    />
  );
};

export default ProductSaveToListButton;
